import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { FilterResult } from './FilterResult'
import classes from './NewsAndSocialContent.module.scss'
import { NewsFilter } from './NewsFilter'
import { selectIsFinishLoadFilters } from './store/slice'
import { getFiltersThunk } from './store/thunk'

export const NewsAndSocialContent = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const isFinishLoadFilters = useSelector(selectIsFinishLoadFilters)

  useEffect(() => {
    dispatch(getFiltersThunk())
  }, [locale])

  if (!isFinishLoadFilters) {
    return <Loading />
  }

  return (
    <div className={['w100 h100 dFlex', classes.filterContainer].join(' ')}>
      <Element
        elementName="div"
        className={classes.filter}
        style={{
          backgroundColor: '#e5e5e5',
        }}
      >
        <NewsFilter />
      </Element>
      <Element
        elementName="div"
        className={['w100', classes.contentRight].join(' ')}
        style={{ backgroundColor: '#fff' }}
      >
        <div className={classes.filterResultsContainer}>
          <FilterResult />
        </div>
      </Element>
    </div>
  )
}
